// extracted by mini-css-extract-plugin
module.exports = {"status":"label_status__QsPaQ","beginner":"label_beginner__3r8MW","advanced":"label_advanced__2se2F","master":"label_master__ePiob"};